module.exports = {
  title: 'GitHub Onboarding with Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2023-09-27',
  slug: 'github-onboarding',
  tags: ['reanimated'],
};
